import { createContext } from "react";
import { TNotificationCtx } from "./TNotification";

export const NotificationContext = createContext<TNotificationCtx | null>(null);
